import { authRoutes } from '../modules/auth';
import { dashboardRoutes } from '../modules/dashboard';
import { organizationRoutes } from '../modules/organizations';
import { onboardingRoutes } from '../modules/onboarding';
import { userRoutes } from '../modules/users';
import { roleRoutes } from '../modules/roles';
import { settingsRoutes } from '../modules/settings';
import { auditRoutes } from '../modules/audit';
import { contractRoutes } from '../modules/contracts';
import { catalogRoutes } from '../modules/catalog';
import { deliveryRoutes } from '../modules/deliveries';
import { financeRoutes } from '../modules/finance';
import { disputeRoutes } from '../modules/disputes';
import { messageRoutes } from '../modules/messages';
import { supportRoutes } from '../modules/support';
import { announcementRoutes } from '../modules/announcements';
import { reportRoutes } from '../modules/reports';
import { subscriptionRoutes } from '../modules/subscriptions';

/**
 * @typedef {Object} AppRoute
 * @property {string} path
 * @property {React.ComponentType | null} element
 * @property {string | null} [permission]
 * @property {boolean} [public]
 * @property {Object | null} [nav]
 */

/** @type {AppRoute[]} */
export const allRoutes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...organizationRoutes,
  ...onboardingRoutes,
  ...userRoutes,
  ...roleRoutes,
  ...settingsRoutes,
  ...auditRoutes,
  ...contractRoutes,
  ...subscriptionRoutes,
  ...catalogRoutes,
  ...deliveryRoutes,
  ...financeRoutes,
  ...disputeRoutes,
  ...messageRoutes,
  ...supportRoutes,
  ...announcementRoutes,
  ...reportRoutes,
];
